export default __webpack_public_path__ + "static/media/bg7.59af8fdb.jpeg";